import React, { Component, Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react'
import { InformationCircleIcon } from '@heroicons/react/outline'
import { FormattedMessage } from 'react-intl';
import toLocalString from '../infrastructure/DateTimeFunctions';

export class RejectReasonsDialog extends Component {
    static displayName = RejectReasonsDialog.name;

    constructor(props) {
        super(props);               
        this.state = { open: false };
                
        this.handleClick = this.handleClick.bind(this);
        this.handleClose = this.handleClose.bind(this);        
    }    

    handleClose() {
        this.setState({ open: false});
    }

    async handleClick(e) {
        e.preventDefault();

        this.setState({ open: true });
    }
               
    static renderTable(reasons) {
        return (<div className="w-full overflow-x-auto">
            <table className='w-full'>
                <thead>
                    <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
                        <th className="px-4 py-3"><FormattedMessage id="RejectReasonCategory" /></th>
                        <th className="px-4 py-3"><FormattedMessage id="Issue" /></th>                  
                        <th className="px-4 py-3"><FormattedMessage id="Description" /></th>
                        <th className="px-4 py-3"><FormattedMessage id="Remark" /></th>
                        <th className="px-4 py-3"><FormattedMessage id="RejectName" /></th>
                        <th className="px-4 py-3"><FormattedMessage id="RejectTime" /></th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
                  {reasons.map(a =>
                      <tr key={a.id} className="bg-gra-50 hover:bg-gray-100 text-gray-700 dark:text-gray-400 text-sm">
                          <td className="px-4 py-3 whitespace-nowrap"><p className="font-semibold">{a.category}</p></td>
                          <td className="px-4 py-3 whitespace-nowrap">{a.issue}</td>
                          <td className="px-4 py-3">{a.description}</td>      
                          <td className="px-4 py-3 whitespace-nowrap">{a.remark}</td>
                          <td className="px-4 py-3">{a.creatorName}</td>      
                          <td className="px-4 py-3">{toLocalString(a.createTime)}</td>                          
                     </tr>
                  )}
                </tbody>
              </table>
            </div>        
      );
    }

    render() {
        const reasons = this.props.reasons;
        let contents = RejectReasonsDialog.renderTable(reasons);
        const { open } = this.state;
        return (
            <div className="ml-4">
                <button onClick={this.handleClick} className="text-indigo-600 hover:text-indigo-900">
                    <FormattedMessage id="Detail"/>
                </button>
                <Transition.Root show={open} as={Fragment}>
                    <Dialog
                        as="div"
                        static
                        className="fixed z-10 inset-0 overflow-y-auto"
                        open={open}
                        onClose={this.handleClose}>
                        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0"
                                enterTo="opacity-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                            >
                                <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                            </Transition.Child>

                            {/* This element is to trick the browser into centering the modal contents. */}
                            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                                &#8203;
                            </span>
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full">
                                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                        <div className="sm:flex sm:items-start">
                                            <div className="mx-auto flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-full bg-yellow-200 sm:mx-0 sm:h-8 sm:w-8">
                                                <InformationCircleIcon className="h-6 w-6 text-yellow-700" aria-hidden="true" />
                                            </div>
                                            <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                                <Dialog.Title as="h3" className="text-lg text-left leading-6 font-medium text-gray-900 mt-2">
                                                    <FormattedMessage id="RejectHistory"/>
                                                </Dialog.Title>
                                            </div>
                                        </div>
                                        <div className="py-10 h-96 overflow-y-auto">
                                            {contents}                      
                                        </div>
                                    </div>
                                    <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse justify-center">

                                        <button
                                            type="button"
                                            className="mt-3 w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                                            onClick={this.handleClose} >
                                            <FormattedMessage id="Close"/>
                                        </button>                                        
                                    </div>
                                </div>
                            </Transition.Child>
                        </div>
                    </Dialog>
                </Transition.Root>
            </div>
        );
    }
}
